module.exports = __webpack_public_path__ + "static/prabhavathi-841edb74ee9ae03fe8a261fc5d5cc222.jpg";